module.exports = __webpack_public_path__ + "img/aqt-sd.fbcbfe0f.png";